import * as React from 'react';
import { useEffect } from 'react';
import { useRouteData } from 'react-static';
import { black } from '../../common/colors';
import { pushToDataLayer } from '../../common/helpers/dataLayer';
import { toKey } from '../../common/helpers/strings';
import { useDebug } from '../../common/hooks/useDebug';
import { useTranslations } from '../../common/translation';
import { BannerCarousel } from '../../components/banner-carousel/BannerCarousel';
import { FeaturedBlogs } from '../../components/featured-blogs/FeaturedBlogs';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { TitleCarousel } from '../../components/title-carousel/TitleCarousel';
import { DefaultLayout } from '../default/DefaultLayout';
import { HomeLayoutProps } from './HomeLayout.props';
import translations from './translations';

// noinspection JSUnusedGlobalSymbols
export default () => {
  const {
    bottomBannerProps,
    bottomCarouselProps,
    featuredBlogsProps,
    locale,
    middleCarouselProps,
    topBannerProps,
    topCarouselProps,
    translatedPaths,
  } = useRouteData<HomeLayoutProps>();
  const { t } = useTranslations(translations, locale);

  const seo = {
    description: t(
      'seoDescription',
      'Home of Warner Bros Movies, TV Shows and Video Games including Harry Potter, DC Comics and more!',
    ),
  };

  useDebug('app:layout:HomeLayout', {
    props: {
      bottomBannerProps,
      bottomCarouselProps,
      featuredBlogsProps,
      locale,
      middleCarouselProps,
      topBannerProps,
      topCarouselProps,
      translatedPaths,
    },
  });

  useEffect(() => {
    pushToDataLayer({ title: 'homepage' });
  }, []);

  return (
    <DefaultLayout
      bgColor={black}
      hideBottomPadding={true}
      key={toKey(`${locale}-home`)}
      locale={locale}
      seo={seo}
      translatedPaths={translatedPaths}
    >
      <HeadTitle title={t('pageTitle', 'Home of WB Movies, TV, Games, and more!')} />
      <BannerCarousel {...topBannerProps} />
      <TitleCarousel {...topCarouselProps} headingTag='h1' lazyLoad={true} />
      <TitleCarousel {...middleCarouselProps} headingTag='h1' lazyLoad={true} />
      <TitleCarousel {...bottomCarouselProps} headingTag='h1' lazyLoad={true} />
      <FeaturedBlogs {...featuredBlogsProps} headingTag='h1' lazyLoad={true} showButton={true} showTitle={true} />
      <BannerCarousel {...bottomBannerProps} lazyLoad={true} />
    </DefaultLayout>
  );
};
